import IconLike from "@/images/trend/icon-like";
import Auther from "./Auther";
import "./Comment.less";
import { getTrendCommentList } from "@/api/trend";
import { API_RESULT_CODE } from "@/config/types/common";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { Toast } from "antd-mobile";
import { TrendCommentItem } from "@/config/types/trend";
import { transTrendTime } from "@/utils/utils";

function CommentItem({ theme, data }: { theme: "light" | "dark"; data: TrendCommentItem }) {
  return (
    <div className="comment-item">
      <div className="comment-header">
        <Auther theme={theme} data={data as any} />
        <div className="comment-like-wrap">
          <span className="comment-like-num">{data.likeNum}</span>
          <IconLike />
        </div>
      </div>
      <div className="comment-text">{data.content}</div>
      {data?.emojiName && <div className="comment-text">{data.emojiName}</div>}
      {Array.isArray(data?.files) && data.files.length > 0 ? (
        <div className="comment-picture comment-text">[图片]</div>
      ) : null}
      <div className="comment-publis-info">
        {transTrendTime(data.createTime)} {data.city || data.province}
      </div>
    </div>
  );
}

export default function Comment({ theme }: { theme: "light" | "dark" }) {
  const parsed = queryString.parse(location.search);
  const [data, setData] = useState<{
    list: TrendCommentItem[];
    pages: number; //页数
    size: number; // 每页条数
    total: number; // 总条数
    current: number; // 当前页数
  }>();
  const getComment = async () => {
    try {
      const { code, data, msg } = await getTrendCommentList({
        trendsId: parsed.id as string,
        pageNum: 1,
        pageSize: 20, // 原值2，显示不全
        asc: false,
      });
      if (code === API_RESULT_CODE.APP_SUCCESS) {
        setData(data);
      } else {
        Toast.show(msg || "动态评论获取失败");
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getComment();
  }, []);
  return data?.total ? (
    <div className={`comment-wrap comment-wrap-${theme}`}>
      <div className="comment-num">评论·{data?.total}</div>
      <div className="comment-list">
        {data?.list?.map((item) => (
          <CommentItem key={item.commentsId} data={item} theme={theme} />
        ))}
      </div>
      {/* <div className="comment-more">
        国聘App内查看更多讨论
        <RightOutline />
      </div> */}
    </div>
  ) : null;
}
